import { defineMessages } from 'react-intl';

export default defineMessages({
    removeActionLabel: {
        id: 'quoteandbind.EnvLineProduct.views.exposures.RemoveActionLabel',
        defaultMessage: 'Delete'
    }
    // add string ids and default values for localization here
});
